import axios from 'Axios';
import {
  ADMIN_DASHBOARD,
  API_ROOT,
  USERS_DASHBOARD,
  AdminUserDetails,
  AdminCompanyDetails,
  AdminDeactivateUser,
  AdminDeactivateUserPerma,
  AdminApproveUser,
  AdminDeclineUser,
} from '../api/Routes';
import moment from 'moment';
function getDashboardDataStart() {
  return {
    type: 'GET_DASHBOARD_DATA_START',
  };
}

function getDashboardDataDone(data) {
  return {
    type: 'GET_DASHBOARD_DATA_DONE',
    dashboardData: data,
  };
}

function getAllAdminUsersDataStart() {
  return {
    type: 'GET_All_ADMIN_USERS_DATA_START',
  };
}

function getAllAdminUsersDataDone(data) {
  return {
    type: 'GET_All_ADMIN_USERS_DATA_DONE',
    users: data,
  };
}
function getSingleAdminUserDataStart() {
  return {
    type: 'GET_SINGLE_ADMIN_USER_DATA_START',
  };
}
function getSingleAdminUserDataDone(data) {
  return {
    type: 'GET_SINGLE_ADMIN_USER_DATA_DONE',
    currentUser: data,
  };
}
function getSingleAdminCompanyDataStart() {
  return {
    type: 'GET_SINGLE_ADMIN_COMPANY_DATA_START',
  };
}
function getSingleAdminCompanyDataDone(data) {
  return {
    type: 'GET_SINGLE_ADMIN_COMPANY_DATA_DONE',
    currentCompany: data,
  };
}
function deactivateUserByIdStart() {
  return {
    type: 'DEACTIVATE_USER_BY_ID_START',
  };
}
function deactivateUserByIdDone(companyId, userId, perma) {
  return {
    type: perma
      ? 'DEACTIVATE_USER_PERMA_BY_ID_DONE'
      : 'DEACTIVATE_USER_BY_ID_DONE',
    companyId,
    userId,
  };
}
function approveUserByIdStart() {
  return {
    type: 'APPROVE_USER_BY_ID_START',
  };
}
function approveUserByIdDone(companyId, userId) {
  return {
    type: 'APPROVE_USER_BY_ID_DONE',
    companyId,
    userId,
  };
}
function disApproveUserByIdStart() {
  return {
    type: 'DISAPPROVE_USER_BY_ID_START',
  };
}
function disApproveUserByIdDone(companyId, userId) {
  return {
    type: 'DISAPPROVE_USER_BY_ID_DONE',
    companyId,
    userId,
  };
}
function adminError(msg) {
  let x = false;
  if (msg) {
    x = msg.includes('User excepti');
  }
  let errorMessage = x ? msg.replace('User exception: ', '') : msg;
  return {
    type: 'ADMIN_ERROR',
    errorMessage,
  };
}
export const getAdminDashboardData = () => {
  return function(dispatch) {
    dispatch(getDashboardDataStart());

    axios
      .get(ADMIN_DASHBOARD)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        const dashboardData = Object.keys(data).map(key => {
          let title = (key.charAt(0).toUpperCase() + key.slice(1)).replace(
            /([a-z0-9])([A-Z])/g,
            '$1 $2'
          );
          return {
            key,
            title,
            count: data[key],
          };
        });
        dispatch(getDashboardDataDone(dashboardData));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};

export const getAllAdminUsersDataByType = (arupUsers, filterBy, params) => {
  const usersType = arupUsers ? '/arup' : '/company';
  const usersFilter = filterBy === 'all' ? '' : '/' + filterBy;
  // const queryParam = params ? params : '';
  return function(dispatch) {
    dispatch(getAllAdminUsersDataStart());

    axios
      .get(USERS_DASHBOARD + usersType + usersFilter, { params: params })
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        data.map(user => {
          let newUser = user;
          Object.keys(newUser).forEach(key => {
            if (!newUser[key]) {
              if (key === 'firstName') {
                newUser[key] = newUser.email;
              } else {
                newUser[key] = '-';
              }
            } else {
              if (key === 'joinedLB' || key === 'lastLoginDate') {
                newUser[key] = moment(newUser[key])
                  .format('YYYY-MM-DD HH:mm:ss')
                  .substr(
                    0,
                    moment(newUser[key]).format('YYYY-MM-DD HH:mm:ss').length -
                      3
                  );
              }
              if (key === 'profileImageId') {
                newUser[key] = `${API_ROOT}/asset/${newUser[key]}`;
              }
            }
          });
          return newUser;
        });
        dispatch(getAllAdminUsersDataDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};

// export const getAllAdminUsersData = getArupUsersFilter => {
//   return function(dispatch) {
//     dispatch(getAllAdminUsersDataStart());

//     axios
//       .get(USERS_DASHBOARD, {
//         params: { getArupUsersFilter: getArupUsersFilter },
//       })
//       .then(response => {
//         // If request is good...
//         const { status, statusText } = response;

//         if (status >= 200 && status < 300) return response.data;

//         let error = new Error(statusText);
//         error.status = status;
//         error.promise = response;
//         throw error;
//       })
//       .then(data => {
//         data.map(user => {
//           let newUser = user;
//           Object.keys(newUser).forEach(key => {
//             if (!newUser[key]) {
//               if (key === 'firstName') {
//                 newUser[key] = newUser.email;
//               } else {
//                 newUser[key] = '-';
//               }
//             } else {
//               if (key === 'joinedLB' || key === 'lastLoginDate') {
//                 newUser[key] = moment(newUser[key]).format('YYYY-MM-DD HH:MM');
//               }
//               if (key === 'profileImageId') {
//                 newUser[key] = `${API_ROOT}/asset/${newUser[key]}`;
//               }
//             }
//           });
//           return newUser;
//         });
//         dispatch(getAllAdminUsersDataDone(data));
//       })
//       .catch(error => {
//         // Error
//         let errorMessage;
//         if (error.response) {
//           errorMessage = error.response.data.message;
//         } else if (error.request) {
//           errorMessage = error.request;
//         } else {
//           errorMessage = error.message;
//         }
//         dispatch(adminError(errorMessage));
//       });
//   };
// };

export const getSingleAdminUserData = (userId, companyId) => {
  return function(dispatch) {
    dispatch(getSingleAdminUserDataStart());

    axios
      .get(AdminUserDetails(userId, companyId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => dispatch(getSingleAdminUserDataDone(data)))
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};

export const getSingleAdminCompanyData = companyId => {
  return function(dispatch) {
    dispatch(getSingleAdminCompanyDataStart());

    axios
      .get(AdminCompanyDetails(companyId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => dispatch(getSingleAdminCompanyDataDone(data)))
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};

export const deactivateUserById = (companyId, userId, perma) => {
  return function(dispatch) {
    dispatch(deactivateUserByIdStart());
    const route = perma ? AdminDeactivateUserPerma : AdminDeactivateUser;
    axios
      .get(route(companyId, userId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => dispatch(deactivateUserByIdDone(companyId, userId, perma)))
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};

export const approveUserById = (companyId, userId) => {
  return function(dispatch) {
    dispatch(approveUserByIdStart());
    axios
      .get(AdminApproveUser(companyId, userId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => dispatch(approveUserByIdDone(companyId, userId)))
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};
export const disApproveUserById = (companyId, userId) => {
  return function(dispatch) {
    dispatch(disApproveUserByIdStart());
    axios
      .get(AdminDeclineUser(companyId, userId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => dispatch(disApproveUserByIdDone(companyId, userId)))
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(adminError(errorMessage));
      });
  };
};
